/* 团队协作 */
<template>
  <div class="project-team">
    <Tabs @on-click="clickTaps">
      <!-- 项目成员 -->
      <TabPane label="项目成员">
        <div class="team-people">
          <Row
            type="flex"
            justify="start"
            class="project-team-tabs"
            v-if="status && status.length > 0"
          >
            <Col
              @click.native="checkTeamList(1)"
              span="3"
              class="ivu-col-bg"
              :class="filter.roleId === 1 ? 'active' : ''"
            >所有（{{status[0] && status[0].qtr}}）</Col>
            <Col
              @click.native="checkTeamList(3)"
              class="ivu-col-bg"
              span="3"
              :class="filter.roleId === 3 ? 'active' : ''"
            >采购（{{status[1] && status[1].qtr}}）</Col>
            <Col
              @click.native="checkTeamList(2)"
              class="ivu-col-bg"
              span="3"
              :class="filter.roleId === 2 ? 'active'  : ''"
            >设计师（{{status[2] && status[2].qtr || 0}}）</Col>
            <Col span="15"></Col>
          </Row>
          <Table :columns="columns" :data="lists" disabled-hover stripe tooltip>
            <template slot-scope="{ row }" slot="loginName">
              <Row :gutter="5" type="flex" justify="center" align="middle">
                <Col span="6">
                  <Avatar
                    icon="ios-person"
                    :src="row.avatarFile && ossPrefix + row.avatarFile.key"
                    size="small"
                  />
                </Col>
                <Col span="18">
                  <p style="text-align:left;" class="pro-data ellipsis">{{row.loginName}}</p>
                </Col>
              </Row>
            </template>
            <template slot-scope="{ row }" slot="realName">
              <p class="pro-data">{{row.realName}}</p>
            </template>
            <template slot-scope="{ row }" slot="phone">
              <p class="pro-data">{{row.phone}}</p>
            </template>
            <template slot-scope="{ row }" slot="roleId">
              <p class="pro-data add">
                <span v-if="row.roleId === 1">管理员</span>
                <span v-if="row.roleId === 2">设计师</span>
                <span v-if="row.roleId === 3">采购</span>
                <Dropdown
                  trigger="click"
                  @on-click="changeRole"
                  v-if="row.roleId !== 1 && permissionFuc('project:team:update')"
                >
                  <i @click="clickItem(row.id)" class="iconfont icon-bianjicopy"></i>
                  <DropdownMenu slot="list">
                    <DropdownItem :name="2">设计师</DropdownItem>
                    <DropdownItem :name="3">采购</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </p>
            </template>
            <template slot-scope="{ row }" slot="status">
              <p class="pro-data" v-if="row.status === 1">未激活</p>
              <p class="pro-data" v-if="row.status === 2">已加入</p>
            </template>
            <template slot-scope="{ row }" slot="joinTime">
              <p class="pro-data">{{row.joinTime | setTimeDate}}</p>
            </template>
            <template slot-scope="{ row, index }" slot="action">
              <Button
                v-if="row.roleId !== 1 && row.status === 2 && permissionFuc('project:team:delete')"
                @click="removeTeam(row)"
                type="text"
              >{{row.status === 1 ? '删除成员' :'移除项目'}}</Button>
              <a
                target="_blank"
                v-if="projectDetail.roleId === 1 && row.status === 2 && row.roleId !== 1"
                :href="row.authorizeFile && ossPrefix + row.authorizeFile.key"
              >
                <Button type="text">{{'查看授权协议'}}</Button>
              </a>
              <span v-else>--</span>
            </template>
          </Table>
        </div>
      </TabPane>

      <!-- 权限管理 -->
      <TabPane label="权限管理">
        <div class="permissions">
          <Row type="flex" justify="start">
            <Col span="3" class="title">
              <i class="iconfont icon-tuandui2"></i>
              <span>用户组</span>
            </Col>
            <Col span="21">
              <Row
                v-if="status && status.length > 0"
                type="flex"
                justify="start"
                class="project-team-tabs"
              >
                <Col
                  @click.native="checkTeamList(2)"
                  span="3"
                  :class="filter.roleId === 2 ? 'active' : ''"
                  class="ivu-col-bg"
                >设计师（{{status[2].qtr}}）</Col>
                <Col
                  @click.native="checkTeamList(3)"
                  span="3"
                  :class="filter.roleId === 3 ? 'active' : ''"
                  class="ivu-col-bg"
                >采购（{{status[1].qtr}}）</Col>

                <Col span="15"></Col>
              </Row>
            </Col>
          </Row>
          <Collapse v-model="collapse">
            <Panel name="1">
              用户组成员
              <div slot="content" class="procurement">
                <Row type="flex" justify="start" v-if="lists && lists.length > 0">
                  <Col span="4" class="members" v-for="(item, index) in lists" :key="index">
                    <Avatar
                      icon="ios-person"
                      :src="item.avatarFile && ossPrefix + item.avatarFile.key"
                    />
                    <i v-if="item.roleId === 1" class="iconfont icon-people"></i>
                    <span class="members-name ellipsis">{{item.loginName}}（{{item.realName}}）</span>
                  </Col>
                </Row>
                <Row type="flex" justify="start" v-else>
                  <Col span="4" class="members">暂无成员</Col>
                </Row>
              </div>
            </Panel>
          </Collapse>
          <Row type="flex" justify="start" class="m-t-50">
            <Col span="3" class="title">
              <i class="iconfont icon-quanxian"></i>
              <span>权限</span>
            </Col>
          </Row>
          <permissions :permissionsList="permissionsList"></permissions>
        </div>
      </TabPane>

      <TabPane label="动态日志">
        <div>
          <div
            v-for="(item, index) in logs"
            :key="index"
            class="time-line"
            v-if="logs && logs.length > 0"
          >
            <p class="top">{{item.nowTime}}</p>
            <Timeline>
              <TimelineItem v-for="(child, i) in item.location" :key="i">
                <p class="action-item">
                  <span class="time" v-if="child.samllTime">{{child.samllTime}}</span>
                  <span class="name" v-if="child.realName">【{{child.realName}}】</span>
                  <span class="action" v-if="child.action">{{child.action}}</span>
                  <span class="content" v-if="child.content">{{child.content}}</span>
                </p>
                <div
                  class="img-action"
                  v-if="setLogFile(child.logFile) && setLogFile(child.logFile).length > 0"
                >
                  <div v-for="(file, fileKey) in setLogFile(child.logFile)" :key="fileKey">
                    <p class="top-action" v-if="file.logFile && file.groupNum === 1">上传</p>
                    <p class="top-action" v-if="file.logFile && file.groupNum === 2">删除</p>
                    <Row
                      class="group-item"
                      type="flex"
                      justify="start"
                      :gutter="10"
                      v-if="file.logFile && file.logFile.length > 0"
                    >
                      <Col
                        style="margin-bottom:10px;"
                        v-for="(fileItem, itemKey) in file.logFile"
                        :key="itemKey"
                      >
                        <z-panelimg
                          :del="false"
                          :src="fileItem.logFile && fileItem.logFile.key ? ossPrefix + fileItem.logFile.key : ''"
                          :height="50"
                          :width="50"
                        ></z-panelimg>
                      </Col>
                    </Row>
                  </div>
                </div>
              </TimelineItem>
            </Timeline>
          </div>
          <div class="m-t-100" style="text-align:center" v-if="logsListsPrve.length > 0">
            <Button
              :disabled="logsListsPrve.length >= logsListsNum"
              style="width:300px;"
              @click="loadingMore"
              :loading="more_loading"
            >{{logsListsPrve.length >= logsListsNum ? '已加载全部' : '加载更多'}}</Button>
          </div>
        </div>
        <div v-if="!logs || logs.length === 0" class="nologs">
          <img src="https://oss.zhulogic.com/logo/404New.png" alt />
          <p>暂无操作日志</p>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import permissions from "./permissions.vue";
import { constructQueryParams } from "@/utils/queryParams.js";
import { timeLine } from "@/utils/timeLine.js";
import { permissionFuc } from "@/utils/permissions.js";
import axios from "axios";
const filter = {
  projectId: "",
  roleId: 1
};
export default {
  data() {
    return {
      permissionFuc: permissionFuc,
      /* 折叠面板 */
      filter: filter,
      collapse: "1",
      columns: [
        {
          title: "成员昵称",
          align: "center",
          slot: "loginName"
        },
        {
          title: "真实姓名",
          align: "center",
          slot: "realName"
        },
        {
          title: "手机号",
          align: "center",
          slot: "phone"
        },
        {
          title: "用户组",
          align: "center",
          slot: "roleId"
        },
        {
          title: "状态",
          align: "center",
          slot: "status"
        },
        {
          title: "加入企业时间",
          align: "center",
          slot: "joinTime"
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
          width: 250
        }
      ],
      lists: [],
      status: [],
      permissionsList: [],
      logs: [],
      timeLine: timeLine,
      logsListsPrve: [],
      filterLogs: {
        pageNum: 1,
        pageSize: 20
      },
      logsListsNum: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    filter.projectId = to.params.id;
    axios
      .get(`/designer_api/project/team` + constructQueryParams(filter), {
        globalLoading: true
      })
      .then(res => {
        next(vm => {
          vm.lists = res && res.list;
        });
      });
  },
  components: { permissions },
  computed: {
    projectDetail() {
      return this.$store.state.projectDetail;
    }
  },
  methods: {
    getLists() {
      this.filter.projectId = this.$route.params.id;
      axios
        .get(`/designer_api/project/team` + constructQueryParams(filter), {
          globalLoading: true
        })
        .then(res => {
          this.lists = res.list;
        });
    },
    /* 获得状态 */
    getStatus() {
      this.filter.projectId = this.$route.params.id;
      axios
        .get(
          `/designer_api/project/team/status_num` + constructQueryParams(filter)
        )
        .then(res => {
          this.status = res;
        });
    },
    /* 切换选项 */
    checkTeamList(roleId) {
      this.filter.roleId = roleId;
      filter.roleId = roleId;
      this.getLists();
    },

    /* 奇幻taps */
    clickTaps(val) {
      if (val === 0) {
        this.filter.roleId = 1;
        filter.roleId = 1;
        this.getLists();
      } else if (val === 1) {
        this.filter.roleId = 2;
        filter.roleId = 2;
        this.getLists();
        this.getPermissionsList();
      } else {
        this.logsListsPrve = []
        this.getUserLogs();
      }
    },

    /* 请求权限列表 */
    getPermissionsList() {
      axios
        .get(
          `/designer_api/project/team/${this.projectDetail.roleId}/permission`
        )
        .then(res => {
          this.permissionsList = res;
        });
    },

    /* 获得用户操作日志 */
    getUserLogs() {
      axios
        .get(
          `/designer_api/project/team/${this.$route.params.id}/log` +
            constructQueryParams(this.filterLogs)
        )
        .then(res => {
          this.logsListsNum = res.total;
          this.logsListsPrve = this.logsListsPrve.concat(res.list);
          this.logs = this.timeLine(this.logsListsPrve, "createTime");
          this.more_loading = false;
        })
        .catch(err => {
          this.more_loading = false;
        });
    },

    /* 加载更多 */
    loadingMore() {
      this.more_loading = true;
      this.filterLogs.pageNum = this.filterLogs.pageNum + 1;
      this.getUserLogs();
    },

    clickItem(id) {
      this.roleClickId = id;
    },

    /* 修改角色 */
    changeRole(roleId) {
      let obj = {
        id: this.roleClickId,
        roleId: roleId
      };
      axios.put(`/designer_api/project/team/role`, obj).then(res => {
        this.$Message.success("角色修改成功");
        this.getLists();
        this.getStatus(this);
      });
    },

    /* 移除项目 */
    removeTeam(row) {
      let title = row.status === 1 ? "删除成员" : "移除成员";
      this.$Modal.confirm({
        title: title,
        loading: true,
        width: 500,
        render: h => {
          return h("div", { class: "delete-dialog" }, [
            h("p", [
              h("i", { class: "iconfont icon-jinggao1 dialog-content-error" }),
              h("span", "重要提示")
            ]),
            h("p", `确定要把此人${title}吗？`)
          ]);
        },
        onOk: () => {
          this.removePeople(row.id);
        }
      });
    },
    /* 移除该项目 */
    removePeople(id) {
      axios.delete(`/designer_api/project/team/${id}`).then(res => {
        this.$Message.success("移除成功");
        this.getLists();
        this.getStatus(this);
        this.$Modal.remove();
      });
    },

    /* 循环logFile按照groupNum匹配 */
    setLogFile(files) {
      if (!files || files.length === 0) return false;
      let ary = [];
      let ary1 = files.filter(item => item.groupNum === 1);
      let ary2 = files.filter(item => item.groupNum === 2);

      let obj1 = {
        groupNum: 1,
        logFile: ary1 && ary1.length > 0 ? ary1 : null
      };
      let obj2 = {
        groupNum: 2,
        logFile: ary2 && ary2.length > 0 ? ary2 : null
      };
      ary.push(obj1);
      ary.push(obj2);
      return ary;
    }
  },
  created() {
    this.getStatus(this);
    this.$on('global:submitCopySuccess', () => {
      this.getLists();
      this.getStatus();
    })
  }
};
</script>

<style lang="scss">
.project-team {
  padding: 0 15px;
  margin-top: -30px;
  .ivu-tabs-bar {
    border: none;
  }
  .ivu-tabs-nav .ivu-tabs-tab {
    color: #a0a0a0;
    text-align: left;
    padding-left: 0px;
  }
  .ivu-tabs-nav .ivu-tabs-tab-active {
    font-weight: 500;
    color: rgba(49, 49, 49, 1);
  }
  .ivu-tabs-ink-bar {
    background-color: #fff;
  }
  .ivu-table-wrapper .ivu-table {
    margin-bottom: 50px;
  }
  .pro-data {
    font-size: 14px;
    font-weight: 400;
    color: rgba(112, 112, 112, 1);
  }
  .pro-data.add {
    i {
      font-size: 12px;
      vertical-align: middle;
      display: inline-block;
      margin-left: 5px;
      cursor: pointer;
      &:hover {
        color: #e56a69;
      }
    }
  }
  button.ivu-btn-text {
    outline: none;
    box-shadow: none;
    background: transparent;
    &:hover {
      span {
        color: #e56a69;
      }
    }
  }
  .project-team-tabs {
    height: 35px;
    background: rgba(241, 241, 241, 1);
    margin: 30px 0;
    margin-top: 5px;
    .ivu-col {
      line-height: 35px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
    }
    .ivu-col-bg {
      &:hover {
        background-color: #313131;
        color: #fff;
      }
    }
    .ivu-col.active {
      background: rgba(49, 49, 49, 1);
      color: #fff;
    }
  }

  .permissions {
    .title {
      i {
        font-size: 25px;
        vertical-align: middle;
        display: inline-block;
        margin-right: 5px;
      }
      span {
        font-size: 16px;
        font-weight: 500;
        color: rgba(49, 49, 49, 1);
        vertical-align: middle;
      }
    }
    .ivu-collapse {
      border: none;
      background-color: #fafafa;
    }
    .ivu-collapse
      > .ivu-collapse-item.ivu-collapse-item-active
      > .ivu-collapse-header {
      border: none;
    }
    .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
      color: #707070;
      font-weight: 500;
      font-size: 14px;
    }
    .ivu-collapse-content {
      padding: 0px;
    }

    .ivu-collapse-content > .ivu-collapse-content-box {
      padding: 0px;
    }

    .procurement {
      padding: 25px;
      padding-bottom: 10px;
      background: #fafafa;
      .members {
        margin-bottom: 30px;
        > i {
          color: #e56a69;
          font-size: 14px;
          vertical-align: middle;
          display: inline-block;
          margin-left: 10px;
        }
        > span {
          font-size: 14px;
          font-weight: 500;
          color: rgba(49, 49, 49, 1);
          display: inline-block;
          margin-left: 10px;
          vertical-align: middle;
        }
        .members-name {
          width: 70%;
        }
      }
    }
  }

  .time-line {
    .top {
      font-size: 14px;
      font-weight: 500;
      margin: 20px 0;
    }
    .action-item {
      margin-top: -8px;

      span {
        font-size: 14px;
        font-weight: 500;
        color: rgba(74, 74, 74, 1);
        display: inline-block;
        vertical-align: middle;
      }
      span.time {
        margin-left: 15px;
      }
      span.action {
        margin: 5px 0;
      }
    }
    .img-action {
      width: 500px;
      background: rgba(241, 241, 241, 1);
      padding: 5px 15px;
      margin-top: 20px;
      .top-action {
        font-size: 14px;
        font-weight: 400;
        color: rgba(74, 74, 74, 1);
        margin: 10px 0;
      }
    }
    .ivu-timeline-item-head-blue {
      background: #e56a69 !important;
      border-color: #e56a69 !important;
      color: #e56a69 !important;
    }
  }
  .nologs {
    img {
      width: 500px;
      display: block;
      margin: 0 auto;
      margin-top: 100px;
    }
    p {
      text-align: center;
      color: #313131;
      font-size: 20px;
      margin-top: 30px;
    }
  }
}
</style>

